module.exports = __webpack_public_path__ + "fonts/almoni-regular-aaa.a4c5468.woff";